import { useState, useEffect, useMemo, ChangeEvent, useCallback, useImperativeHandle, useRef } from "react";
import { MetaDataList, DeleteNewMeta } from "../../api/api";
import Cookies from "js-cookie";
import { AgGridReact } from "ag-grid-react";
import { GridReadyEvent } from "ag-grid-community";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Container, Offcanvas, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button } from "../../components/Button/Button";
import {useGetMetadataList} from "../../data/data"
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { boolean } from "yup";
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

type ProcessListProps = {
  handleChange: ({ id }: { id: string }) => void;
  refetchMetadataList: () => void;
};

const ProcessList: React.FC<ProcessListProps> = ({ handleChange, refetchMetadataList }) => {
  const [metaList, setMetaList] = useState<any>(null);
  const [show, setShow] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [selectedMetaID, setSelectedMetaID] = useState<any>(null);
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  const { data, isFetching, refetch } = useGetMetadataList(
    Cookies.get("newJwt")
  );
  // actions
  function editData(data: any) {
    handleChange({ id: data.data.id });
  }

  function deleteData(data: any) {
    setSelectedMetaID(data.data);
    setShowModel(true);
  }
  // slider control
  const closeSidebar = () => {
    setShow(false);
  };
  const handleClose = () => {
    setShowModel(false);
  };
  const handleChangeDelete = () => {
    const id = selectedMetaID.id;
    DeleteNewMeta(id, Cookies.get("newJwt"))
    .then((response) => {
      // Handle the response if needed
      setShowModel(false);
      toast.success("Deleted successfully!", {
        position: toast.POSITION.TOP_RIGHT,
      });
      refetch();
    })
    .catch((error) => {
      // Handle the error if needed
      console.log(error);
      toast.error("Error Deleting Metadata!", {
        position: toast.POSITION.TOP_RIGHT,
      });
    });
  };

  const onGridReady = useCallback(
    (params: GridReadyEvent) => {
      setMetaList(data);
    },
    [data]
  );
  // create columns
  const defColumnDefs = useMemo(
    () => ({
      sortable: true,
      refreshCells: true,
      //flex:1
    }),
    []
  );
  const [columns, setColumns] = useState([
    {
      headerName: "Name",
      field: "name",
      flex: 1,
    },
    {
      headerName: "SP Name",
      field: "spName",
      sortable: true,
      width: 250,
    },
    {
      headerName: "Description",
      field: "description",
      width: 250,
    },
    {
      headerName: "Actions",
      field: "",
      cellClass: "text-start",
      width: 85,
      cellRendererFramework: (params: any) => {
        return (
          <>
            <span
              onClick={() => editData({ data: params.data })}
              className="cursor-pointer"
            >
              <i title="edit" className="fas fa-fw fa-edit"></i>
            </span>
            <span
              onClick={() => deleteData({ data: params.data })}
              className="cursor-pointer ml-4"
            >
              <i title="delete" className="fas fa-fw fa-trash"></i>
            </span>
          </>
        );
      },
    },
  ]);


  const handleExportExcel = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `$${params.value.toFixed(2)}`;
        }
        if (params.column.colId.includes("Locked")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }

        if (params.column.colId.includes("Status")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }
       
        if (typeof params.value === "undefined" ) {
          // Format numbers as currency with the currency symbol
          return `--`;
        }
        return params.value !== null ? `$${params.value}` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const handleExportPdf = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape
  
    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;
  
    doc.setFontSize(8);
  
    const title = "Task List";
    const headers = [
      [
        "Name",
        "SP Name",
        "Description",
      ],
    ];
  
    const transactionData = data?.map((e: any) => [
      e.name !== null ? `${e.name}` : "--",
      e.spName !== null ? `${e.spName}` : "--",
      e.description !== null ? `${e.description}` : "--",
    ]);
  
    let content = {
      startY: 50,
      head: headers,
      body: transactionData,
    };
  
    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("Task.pdf");
  };

  return (
    <div>
        <div className="my-2 col-sm-12 text-end">
          <i
            className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
            style={{ fontSize: "16px" }}
            onClick={handleExportExcel}
          ></i>
          <i
            className="align-middle far fa-fw fa-file-pdf cursor-pointer"
            onClick={() => handleExportPdf()}
            style={{ fontSize: "16px" }}
          ></i>
        </div>
      <div className="">
        <div
          className="ag-theme-alpine"
          style={{
            height: "500px",
            width: "100%",
          }}
        >
          {isFetching ? (
            <div className="w-100 grid_loader">
              <div className="spinner-border text-dark me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <AgGridReact
              ref={dataGridRefMain}
              rowData={metaList}
              columnDefs={columns}
              defaultColDef={defColumnDefs}
              onGridReady={onGridReady}
              animateRows={true}
              popupParent={document.body}
              pagination={true}
              paginationPageSize={20}
            ></AgGridReact>
          )}
        </div>
        <Offcanvas
          backdrop="false"
          placement="end"
          show={show}
          onHide={closeSidebar}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Create User</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>side slider</Offcanvas.Body>
        </Offcanvas>
      </div>
      <Modal
        show={showModel}
        onHide={handleClose}
        centered
        className="modelComponent"
      >
        <Modal.Header closeButton>
          <Modal.Title>Meta data</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you Sure, You want to Delete Meta data</Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            className="btn-primary"
            size="btn-xs"
            children="Close"
            onClick={handleClose}
          />

          <Button
            type="submit"
            className="btn-primary"
            size="btn-xs"
            children="Delete"
            onClick={handleChangeDelete}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export { ProcessList };
